/* eslint-disable */
const configsHenan = {
  title: '河南省工程保证信息管理系统v3.0',
  subtitle: '河南省工程担保行业协会主办',
  copyRightHolder: '河南省工程担保行业协会',
  siteStartYear: 2011,
  siteICPNo: '豫ICP备18017773号',
  copyRightHolderHome: 'http://www.hnacs.org.cn',
  hotline: '0371-69179969 / 66255260',
  techSupport: '思创网联(北京)科技发展有限公司',
  techSupportHome: 'https://www.sclinker.com',
  welcomeBackgroundImageUrl: 'login_bg_1.jpg', // 01.png
  enableSmsLogin: true, // 是否允许短信登录
  enableRegister: false, // 是否开放注册
  enableEGua: true, // 是否启用电子保函
  loginLayoutName: '_Center',
  showPublishedGuarantors: false, // 是否展示保证人公示名单
  needTerminateUploadReport: true, // 是否需要解除保函上传竣工报告
  enableGenSupvMngGua: true, // 是否允许总监管人管理保函
  enableSupvMngGua: true, // 是否允许监管人管理保函
  enableGenSupvMngGuarantor: true, // 是否允许总监管人管理保证人
  enableSupvMngGuarantor: true, // 是否允许监管人管理保证人
  enableGuarantorRegister: false, // 是否允许承保人自主注册
  guarantorRegisterAttachmentRequirements: [], // 承保人注册时要求上传附件清单
  guaranteeRenewalAttachmentRequirements: [
    {
      name: '续保合同',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      maxLength: 5 * 1024, // kb
      fileCountLimit: 5,
      required: true
    },
  ], // 续保时要求上传附件清单
  guaranteeRenewalEnabled: true,
}

const configsPuyang = {
  title: '思创工程保证信息管理系统v3.0',
  subtitle: '',
  copyRightHolder: '思创网联(北京)科技发展有限公司',
  siteStartYear: 2011,
  siteICPNo: '京ICP备16022875号',
  copyRightHolderHome: 'https://www.sclinker.com',
  hotline: '400-811-5272',
  techSupport: '',
  techSupportHome: '',
  welcomeBackgroundImageUrl: 'login_bg_1.jpg', // 01.png
  enableSmsLogin: true, // 是否允许短信登录
  enableRegister: false, // 是否开放注册
  enableEGua: true, // 是否启用电子保函
  loginLayoutName: '_2Col',
  showPublishedGuarantors: false, // 是否展示保证人公示名单
  needTerminateUploadReport: true, // 是否需要解除保函上传竣工报告
  enableGenSupvMngGua: true, // 是否允许总监管人管理保函
  enableSupvMngGua: true, // 是否允许监管人管理保函
  enableGenSupvMngGuarantor: true, // 是否允许总监管人管理保证人
  enableSupvMngGuarantor: true, // 是否允许监管人管理保证人
  enableGuarantorRegister: false, // 是否允许承保人自主注册
  guarantorRegisterAttachmentRequirements: [], // 承保人注册时要求上传附件清单
  guaranteeRenewalAttachmentRequirements: [
    {
      name: '续保合同',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      maxLength: 5 * 1024, // kb
      fileCountLimit: 5,
      required: true
    },
  ], // 续保时要求上传附件清单
  guaranteeRenewalEnabled: true,
}

const configsHubei = {
  title: '工程保证信息管理系统v3.0',
  subtitle: '',
  copyRightHolder: '思创网联(北京)科技发展有限公司',
  siteStartYear: 2011,
  siteICPNo: '京ICP备16022875号',
  copyRightHolderHome: 'http://www.sclinker.com',
  hotline: '400-811-5272',
  techSupport: '思创网联(北京)科技发展有限公司',
  techSupportHome: 'https://www.sclinker.com',
  welcomeBackgroundImageUrl: '002.jpg', // 01.png
  enableSmsLogin: false, // 是否允许短信登录
  enableRegister: false, // 是否开放注册
  enableEGua: true, // 是否启用电子保函
  loginLayoutName: '_2Col',
  showPublishedGuarantors: true, // 是否展示保证人公示名单
  needTerminateUploadReport: true, // 是否需要解除保函上传竣工报告
  enableGenSupvMngGua: true, // 是否允许总监管人管理保函
  enableSupvMngGua: true, // 是否允许监管人管理保函
  enableGenSupvMngGuarantor: true, // 是否允许总监管人管理保证人
  enableSupvMngGuarantor: true, // 是否允许监管人管理保证人
  enableGuarantorRegister: false, // 是否允许承保人自主注册
  guarantorRegisterAttachmentRequirements: [], // 承保人注册时要求上传附件清单
}

const configsGansu = {
  title: '甘肃省工程保证信息管理系统v1.0',
  subtitle: '甘肃省土木建筑学会主办',
  copyRightHolder: '甘肃省土木建筑学会',
  siteStartYear: 2020,
  siteICPNo: '陇ICP备06000812号',
  copyRightHolderHome: 'http://www.gstmxh.com/',
  hotline: '0931-7750132',
  techSupport: '思创网联(北京)科技发展有限公司',
  techSupportHome: 'https://www.sclinker.com',
  welcomeBackgroundImageUrl: 'bg_01.jpg',
  enableSmsLogin: false, // 是否允许短信登录
  enableRegister: true, // 是否开放注册
  enableEGua: true, // 是否启用电子保函
  loginLayoutName: '_Center',
  showPublishedGuarantors: true, // 是否展示保证人公示名单
  needTerminateUploadReport: true, // 是否需要解除保函上传竣工报告
  enableGenSupvMngGua: true, // 是否允许总监管人管理保函
  enableSupvMngGua: true, // 是否允许监管人管理保函
  enableGenSupvMngGuarantor: true, // 是否允许总监管人管理保证人
  enableSupvMngGuarantor: true, // 是否允许监管人管理保证人
  enableGuarantorRegister: true, // 是否允许承保人自主注册
  guarantorRegisterAttachmentRequirements: [
    {
      name: '法定代表人授权委托书',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '法定代表人身份证扫描件',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 2,
      required: true
    },
    {
      name: '委托人身份证扫描件',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 2,
      required: false
    },
    {
      name: '营业执照',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 2,
      required: true
    },
    {
      name: '公司章程',
      formats: 'pdf',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '开户许可证',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '董事会或股东会决议',
      formats: 'pdf',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '办公地点房产证或房屋租赁协议',
      formats: 'pdf',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '开展工程保证业务的相关管理制度',
      formats: 'pdf',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '开展工程保证业务流程图',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '工程风险评价和风险管控制度',
      formats: 'pdf',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '开展工程保证业务使用的印章图鉴',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '工程担保业务承诺书',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '行业自律公约书',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    }
  ], // 承保人注册时要求上传附件清单
  guarantorBankRegisterAttachmentRequirements: [
    {
      name: '甘肃省工程保证人备案申请表',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '公司营业执照扫描件',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '法定代表人授权委托书（身份证原件复印留存）',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '设立分支机构文件及营业执照',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 5,
      required: true
    },
    {
      name: '开展工程保证业务的相关管理制度（加盖公章）',
      formats: 'pdf',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 10,
      required: true
    },
    {
      name: '工程风险评价和风险管控制度（加盖公章）',
      formats: 'pdf',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 10,
      required: true
    },
    {
      name: '开展工程保证业务流程图（加盖公章）',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '开展工程保证业务使用的印章图鉴',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '工程担保业务承诺书（加盖公章）',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    },
    {
      name: '甘肃省工程保证行业自律公约书（加盖公章）',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      fileSizeLimit: 5 * 1024, // kb
      fileCountLimit: 1,
      required: true
    }
  ], // 承保人注册时要求上传附件清单
  // 资料清单实例模板下载地址
  guarantorRegisterAttachmentSampleUrl: 'https://gsacs-demo.oss-cn-beijing.aliyuncs.com/%E8%B5%84%E6%96%99%E6%B8%85%E5%8D%95-%E6%8B%85%E4%BF%9D%E5%85%AC%E5%8F%B8.rar',
  guarantorBankRegisterAttachmentSampleUrl: 'https://gsacs-demo.oss-cn-beijing.aliyuncs.com/%E8%B5%84%E6%96%99%E6%B8%85%E5%8D%95-%E6%8B%85%E4%BF%9D%E5%85%AC%E5%8F%B8.rar',
  guarantorRegisterAttachmentSampleText: '资料清单模板',
  guaranteeRenewalAttachmentRequirements: [
    {
      name: '续保合同',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      maxLength: 5 * 1024, // kb
      fileCountLimit: 5,
      required: true
    },
    {
      name: '续保保费转账凭证',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      maxLength: 5 * 1024, // kb
      fileCountLimit: 5,
      required: true
    },
    {
      name: '续保发票',
      formats: 'pdf,jpg,jpeg,png,tif,tiff',
      maxLength: 5 * 1024, // kb
      fileCountLimit: 5,
      required: true
    }
  ], // 续保时要求上传附件清单
  guaranteeRenewalEnabled: true,
}

/* eslint-enable */
const configs = configsPuyang

const getSysConfig = (key) => {
  let value = null
  if (configs) {
    if (configs[key]) {
      return configs[key]
    } else {
      return value
    }
  } else {
    return value
  }
}

module.exports = getSysConfig
